import React from "react"
import Tooltip from "../../common/components/Tooltip"
import { Marker } from "react-mapbox-gl"
import { getMapIconPNG } from "../../utilities/map"
import { getGradeLabel } from "../../utilities/grades"
import GradeContext from "../../context/GradeContext"

// HACK
// https://github.com/alex3165/react-mapbox-gl/issues/217
// TODO: REMOVE AFTER UPDATE TO REACT-MAPBOX-GL V4
const onMarkerWheel = (event) => {
  event.preventDefault()

  const interactiveElement = document.querySelector(".mapboxgl-interactive") // mapElement can be any parent of the .mapboxgl-interactive created by the library (even body)
  if (interactiveElement) {
    const { nativeEvent } = event
    const eventCopy = new nativeEvent.constructor(nativeEvent.type, nativeEvent)
    interactiveElement.dispatchEvent(eventCopy)
  }
}

const MapMarker = (props) => {
  const { feature, isPrimary, onClick } = props
  if (!feature) {
    return null
  }

  return (
    <GradeContext.Consumer>
      {(gradeType) => (
        <Marker
          draggable
          coordinates={feature.location.coordinates}
          anchor="center"
          className={isPrimary ? "primary" : ""}
          onClick={() => {
            onClick(feature)
          }}
        >
          <img
            onWheel={onMarkerWheel}
            data-tip
            data-tooltip-id={"marker-" + feature.slug}
            alt={feature.type + " marker"}
            className={
              isPrimary
                ? "map-" + feature.type + "-orange"
                : "map-" + feature.type + "-blue"
            }
            src={getMapIconPNG(feature.type, isPrimary)}
          />
          <Tooltip class="card-tooltip" id={"marker-" + feature.slug}>
            <h6 className="no-wrap">
              {feature.name} {feature.grade ? "-" : ""}{" "}
              {getGradeLabel(feature.grade, feature.type, gradeType)}
            </h6>
          </Tooltip>
        </Marker>
      )}
    </GradeContext.Consumer>
  )
}

MapMarker.propTypes = {}

export default MapMarker
